import { calcSpacing } from 'src/components/foundations';
import styled from 'styled-components';

export const ReportDetailsContainerStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: ${calcSpacing(2)}px;
  row-gap: ${calcSpacing(2)}px;
`;
